@if (loading) {
  <div class="spinner-container p-absolute">
    <mat-spinner class="primary" [diameter]="30"></mat-spinner>
  </div>
}
@if (!loading) {
  <div class="page page-error">
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-12 align-self-center">
          <h1 class="title">
            <span class="code">404</span>
            {{ 'global.not_found' | transloco }}
          </h1>
          <div class="info">
            @if (url) {
              <div class="d-block">
                {{ url }}
              </div>
            }
            @if (requestId) {
              <div class="d-block">request_id: {{ requestId }}</div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
